import { useRouter } from 'next/router';
import React from 'react';

export type RootMarginParam = `${number}px`;

export const useIntersection = ({
  ref,
  callBack,
  threshold = 0.51,
  rootMargin = '0px',
  root = null,
}: {
  callBack: (isIntersecting: boolean) => void;
  ref: React.RefObject<HTMLDivElement>;
  threshold?: number;
  rootMargin?: RootMarginParam;
  root?: Element | Document | null;
}) => {
  const router = useRouter();

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          callBack(entry.isIntersecting);
        }
      },
      {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [callBack, ref, root, rootMargin, router, threshold]);
};
